import request from '../request';

const BASE_URL = `/library/service`;

/**
 * Fetches a service types
 *
 * @returns {Promise<Object>} - The API response.
 */
export const getServiceTypes = async () => await request.get('servicetypes');

/**
 * Save a library itinerary service.
 *
 * @param {Object} payload - The service data to save.
 * @returns {Promise<Object>} - The API response.
 */
export const createLibraryService = async (payload) =>
  await request.post(`${BASE_URL}`, payload);

/**
 * Delete a library itinerary service.
 *
 * @param {number} serviceId - The library itinerary service ID.
 * @returns {Promise<Object>} - The API response.
 */
export const deleteLibraryService = async (serviceId) =>
  await request.delete(`${BASE_URL}/${serviceId}`);

/**
 * Update a library itinerary service.
 *
 * @param {number} serviceId - The library itinerary service ID.
 * @param {Object} payload - The service data to save.
 * @returns {Promise<Object>} - The API response.
 */
export const updateLibraryService = async (serviceId, payload) =>
  await request.put(`${BASE_URL}/${serviceId}`, payload);

/**
 * Fetches a library itinerary service by id.
 *
 * @param {number} serviceId - The library itinerary service ID.
 * @returns {Promise<Object>} - The API response.
 */
export const getLibraryService = async (serviceId) =>
  await request.get(`${BASE_URL}/${serviceId}`);
